<template>
<div class="table-content-wrapper">
   <table class="dataset-table">
      <thead>
         <th>Dataset Name</th>
         <th>Concept ID</th>
         <th class="sortable" v-on:click="sort_by_field('ProcessingLevel')">Processing Level <i class="fas fa-sort"></i></th>
         <th>Spatial Coverage</th>
         <th class="sortable" v-on:click="sort_by_field('start')">Start Date <i class="fas fa-sort"></i></th>
         <th class="sortable" v-on:click="sort_by_field('end')">End Date <i class="fas fa-sort"></i></th>
         <th>Temporal Resolution</th>
         <th>Format</th>
         <th>Capabilities</th>
         <!--<th>Status</th>-->
      </thead>
      <tbody>
         <tr>
         <td colspan="4" v-if="filtered_datasets.length == 0">No Datasets.</td>
         </tr>
         <tr v-for="(dataset, index) in filtered_datasets" :key="index" :class="td_alternate_class(index)">
            <td class="name"><span v-if="dataset_url(dataset)"><a :href="dataset_url(dataset)" target="_blank">{{datasetFieldValue(dataset,['EntryTitle'])}}</a></span><span v-else>{{datasetFieldValue(dataset,['EntityTitle'])}}</span><span v-if="datasetFieldValue(dataset,['ShortName'])"><br/>({{datasetFieldValue(dataset,['ShortName'])}})</span></td>
            <td class="concept-id">{{dataset['meta']['concept-id']}}</td>
            <td class="processing-level">
               {{datasetFieldValue(dataset,['ProcessingLevel','Id'])}}
            </td>
            <td class="spatial">
               <div>
                  <div v-for="(coverage_bound, key) in dataset_coverage_bound(datasetFieldValue(dataset,['SpatialExtent']))" :key="key">
                     <div class="coverage_field"><span class="label">N: </span>{{coverage_bound['N']}}<br/><span class="label">S: </span>{{coverage_bound['S']}}</div>
                     <div class="coverage_field"><span class="label">W: </span>{{coverage_bound['W']}}<br/>
                     <span class="label">E: </span>{{coverage_bound['E']}}</div>
                  </div>
               </div>
               <div>
                  <div v-for="(coverage_point, key) in dataset_coverage_bounding_points(datasetFieldValue(dataset,['SpatialExtent']))" :key="key">
                     <div class="coverage_field"><span class="label">Long: </span><br/>{{coverage_point[0]}}&#176;</div>
                     <div class="coverage_field"><span class="label">Lat: </span><br/>{{coverage_point[1]}}&#176;</div>
                  </div>
               </div>
            </td>
            <td class="temporal_start">
               <div v-html="dataset_temporal_output(datasetFieldValue(dataset,['TemporalExtents']), 'start')" />
            </td>
            <td class="temporal_end">
               <div v-html="dataset_temporal_output(datasetFieldValue(dataset,['TemporalExtents']), 'end')" />
            </td>
            <td class="latency">
               <div v-if="datasetFieldValue(dataset,['TemporalKeywords']) != undefined && datasetFieldValue(dataset,['TemporalKeywords'])[0] != undefined">
               {{datasetFieldValue(dataset,['TemporalKeywords'])[0]}}
               </div>
            </td>
            <td class="format">
               {{datasetFieldValue(dataset,['ArchiveAndDistributionInformation','FileDistributionInformation','0','Format'])}}
            </td>
            <td class="capabilities">
            <div class="capabilities-wrapper" v-if="dataset['meta']['associations'] != undefined">
               <div v-for="(item, key) in capabilities" :key="key">
                  <span v-if="capability_filter_count(item, dataset).length > 0" :class="capabilities_service_classes(key.toLowerCase(), item, dataset['meta']['associations'])" :title="key" v-on:click="show_services_tools_modal({'dataset':dataset,'capability':key}, item, dataset['meta']['associations'])">{{key}}</span>
               </div>
            </div>
            </td>
            <!--<td class="status">
               {{datasetFieldValue(dataset,['CollectionProgress'])}}
            </td>-->
         </tr>
      </tbody>
   </table>
   <div class="more-link" v-if="filtered_item_count > load_item_count">
      <button class="eui-btn--blue" v-on:click="loadMore()">More</button>
   </div>
</div>
</template>

<script>
import {mapState,mapMutations} from "vuex";
import datasets_processing from './mixins/datasets_processing';
import table_row_alternate_class from './mixins/table_row_alternate_class';

export default {
   name: "DatasetTable",
   mixins: [table_row_alternate_class,datasets_processing],
   computed: {
      ...mapState([
         "cloud_datasets",
         "basePath",
         'load_item_count',
         'filtered_item_count',
         'capabilities',
         'umm_s'
      ])
   },
   methods: {
      ...mapMutations([
         "SET_SORT_BY",
         "SET_SCIENCE_KEYWORD_MODAL_DATA",
         "SET_SERVICES_TOOLS"
      ]),
      sort_by_field: function(sort_field) {
         this.SET_SORT_BY(sort_field);
      }
   }
}
</script>